import './FocusMarketingSkeleton.scss';

const FocusMarketingSkeleton = () => {

  return (
    <div className="focus__marketing__section__skeleton">
      <div className="design__arrow__skeleton">
        <div className="arrow__wrapper__skeleton">
          <div className='arrow__down'></div>
        </div>
      </div>
      <div className="focus__marketing__section__wrapper__skeleton">
        <div className="focus__marketing__section__item__desc__skeleton">
          <div className="focus__marketing__section__item__desc__quote__skeleton">
            {[...Array(2)].map((_, i) => (
              <div key={i} className="focus__marketing__section__item__desc__quote__title__skeleton"></div>
            ))}
            <div className="focus__marketing__section__item__desc__quote__title__skeleton--primary"></div>
          </div>
          <div className="focus__marketing__section__item__desc__article__skeleton">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="focus__marketing__section__item__desc__article__text__skeleton"></div>
            ))}
            <div className="focus__marketing__section__item__desc__article__text__skeleton--primary"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FocusMarketingSkeleton;